<template>
    <div>
        <PaymentTransactionList/>
    </div>
</template>

<script>
import PaymentTransactionList from '../../../components/tax/payments/paymentTransactionList.vue';

export default {
  name: 'Payments',
  data: () => ({

  }),
  components: {
    PaymentTransactionList,
  },
};
</script>
